// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__1oH_F","title":"content_title__3VGZZ","text1":"content_text1__3AoOq","text2":"content_text2__3Sx_l","tooltipMobile":"content_tooltipMobile__1ZPRR"};